<template>
  <path d="M6 15l6-6 6 6" stroke="currentColor" stroke-width="1.8" />
</template>
